module.exports = "<div class=row ng-controller=ImproveTimeReportsMapGroupSpentTimeController> <div class=col-lg-12> <div class=\"ibox float-e-margins\"> <div class=ibox-title> <h5>Cost pools <small></small> </h5> <div ibox-tools></div> </div> <div class=ibox-content> <crud-neamtime-client-cost-pool-compact-list></crud-neamtime-client-cost-pool-compact-list> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/sections/2-time/value-model.cost-pools.html
// module id = 4086
// module chunks = 86